module.exports = __webpack_public_path__ + "static/img/Jesse-McLean.4a8455b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Jesse-McLean.jpg
// module id = BB/R
// module chunks = 0